import { Adresse } from './adresse';

export class Parent {
    civilite: string;
    nom: string;
    prenom: string;
    mail: string;
    mobile: string;
    telephonePro: string;
    telephoneDomicile: string;
    
    rue: string;
    codePostal: string;
    ville: string;

    profession: string;
    categorie: string = "Non précisé";
    employeur: string;
    salaries: string= "Non précisé";

    isole: boolean;
    handicap: boolean;

    constructor() {
    }
}